import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { newKey } from '../../../tools/mockData'
import { saveLocalAccessKeysAsync } from '../../api/keyApi'
import { KeyEntityResponseDto } from '../../api/kmsapiclient'
import { KeyInfo } from '../../components/common/types'
import { UPDATE_KEYS_PERMISSION } from '../../redux/actions/actionTypes'
import {
  apiCallError,
  beginApiCall,
  endApiCall,
} from '../../redux/actions/apiStatusActions'
import { updateKeySuccess } from '../../redux/actions/keyActions'
import { store, useAppDispatch } from '../../redux/configureStore'
import { Keys } from '../../redux/reducers/initialState'
import KeyForm from '../common/KeyForm'
import { usePermissions } from '../common/permission/usePermissions'
import { getKeyBySlug } from '../common/utils'

type EditKeyPageProps = {
  match: any
  history: any
}

export const EditKeyPage = ({ match, history }: EditKeyPageProps) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const { checkPermissions } = usePermissions()
  const [saving, setSaving] = useState(false)

  const keys = useSelector((state: Keys) =>
    Object.entries(state.keys).length === 0 ||
    Object.entries(state.keys.keys).length === 0
      ? []
      : state.keys.keys,
  )

  // Redirect user to homepage if user refreshes on edit key page which causes redux keystore to be cleared
  if (keys.length === 0) {
    history.push('/')
  }

  const [keyInfo, setKeyInfo] = useState<any>(
    match.params.slug && keys.length !== 0
      ? (getKeyBySlug(keys, match.params.slug) as KeyInfo)
      : newKey,
  )

  useEffect(() => {
    const savingKey = async () => {
      try {
        await performSaveKey(keyInfo)
        history.push('/keys')
      } catch (error) {
        setSaving(false)
      }
    }
    if (saving) {
      savingKey()
    }
  }, [saving])

  const handleChange = (event) => {
    const { name, value } = event.target
    setKeyInfo((prevKey) => ({
      ...prevKey,
      [name]: value,
    }))
  }

  const handleSave = () => {
    setSaving(true)
  }

  const handleGoBack = () => {
    history.push('/keys')
  }

  const performSaveKey = async (key) => {
    checkPermissions(store.getState(), UPDATE_KEYS_PERMISSION)

    dispatch(beginApiCall())
    try {
      const savedKey: KeyEntityResponseDto = await saveLocalAccessKeysAsync(key)
      if (savedKey != null) {
        dispatch(updateKeySuccess(savedKey))
        toast.success(t('key.key_saved'))
      } else {
        dispatch(endApiCall())
        toast.error(t('key.key_save_failed'))
      }
    } catch (error) {
      dispatch(apiCallError())
      throw error
    }
  }

  return (
    <KeyForm
      keyInfo={keyInfo}
      onChange={handleChange}
      onSave={handleSave}
      onGoBack={handleGoBack}
    />
  )
}
